module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_html.js
// module id = 1564
// module chunks = 1